import { jsx as d, jsxs as I, Fragment as G } from "react/jsx-runtime";
import { memo as M, useState as Q, useRef as _, useEffect as l, useMemo as g, useCallback as P } from "react";
import { u as o } from "../../../styled-components.browser.esm-BFmoFexH.js";
import { Select as C } from "antd";
import { _ as s, N as a, L as c } from "../../../dummyModel-DGc8qBEQ.js";
import { g as D, b as $, f as j, l as O } from "../../../utils-Mz58x57M.js";
import H from "./FilterTypeDescription.js";
import { useLanguageResolver as h } from "@biron-data/react-contexts";
import X from "./inputs/FilterValueMatch.js";
import q from "./inputs/FilterPattern.js";
import z from "./inputs/FilterScalar.js";
import J from "./inputs/FilterRange.js";
const de = M(({
  filter: i,
  temporaryFilter: e,
  isEditable: S,
  handleFilterChange: A,
  handleTemporaryFilterChange: t,
  withBackground: T,
  getPopupContainer: x,
  onApply: N,
  onFocus: n,
  onBlur: E,
  loadDictionaryEntries: b
}) => {
  const W = h(), f = D(), w = $(i, W), [u, k] = Q(f(e)), R = j(u), v = _(), L = _(!1);
  l(() => {
    v && v.current && L.current && v.current.focus();
  }, [u]), l(() => {
    L.current = !1, k(f(i));
  }, [i, f]);
  const U = g(() => {
    switch (e.predicate.operator) {
      case s.IN:
        return /* @__PURE__ */ d(X, { ref: v, filter: e, handleFilterChange: t, withBackground: T, getPopupContainer: x, onApply: N, onFocus: n, onBlur: E, loadDictionaryEntries: b });
      case s.Like:
      case s.Match:
        return /* @__PURE__ */ d(q, { ref: v, filter: i, temporaryFilter: e, type: u, handleFilterChange: A, handleTemporaryFilterChange: t, onFocus: n, onBlur: E });
      case s.GT:
      case s.EQ:
      case s.GTE:
      case s.LT:
      case s.LTE:
        return /* @__PURE__ */ d(z, { ref: v, filter: i, temporaryFilter: e, type: u, handleFilterChange: A, handleTemporaryFilterChange: t, onFocus: n, onBlur: E });
      case s.BETWEEN:
        return /* @__PURE__ */ d(J, { ref: v, filter: i, temporaryFilter: e, type: u, handleFilterChange: A, handleTemporaryFilterChange: t, onFocus: n, onBlur: E });
      default:
        return e.predicate;
    }
  }, [e, t, T, x, N, n, E, b, i, u, A]), V = P((p) => {
    switch (L.current = !0, k(p), p) {
      case a.VALUE_SELECTION: {
        t({
          ...e,
          type: c.dimension,
          dimensionCode: e.reference.code,
          predicate: {
            ...e.predicate,
            operator: s.IN,
            value: {
              "@type": c.VALUE_LIST,
              values: e.predicate.value["@type"] === c.VALUE_LIST ? e.predicate.value.values : []
            }
          }
        });
        break;
      }
      case a.REGEX: {
        t({
          ...e,
          type: c.dimension,
          dimensionCode: e.reference.code,
          predicate: {
            ...e.predicate,
            operator: s.Match,
            value: {
              "@type": c.PATTERN,
              pattern: e.predicate.value["@type"] === c.PATTERN ? O(e) : "",
              caseSensitive: !1
            }
          }
        });
        break;
      }
      case a.START_WITH:
      case a.END_WITH:
      case a.INCLUDE:
        t({
          ...e,
          type: c.dimension,
          dimensionCode: e.reference.code,
          predicate: {
            operator: s.Like,
            value: {
              "@type": c.PATTERN,
              pattern: e.predicate.value["@type"] === c.PATTERN ? R(O(e), p) : R(" ", p),
              caseSensitive: !1
            },
            negate: e.predicate.negate
          }
        });
        break;
      case a.EQUAL:
        t({
          ...e,
          predicate: {
            ...e.predicate,
            operator: s.EQ,
            value: {
              "@type": c.SCALAR,
              value: e.predicate.value["@type"] === c.SCALAR ? e.predicate.value.value : void 0
            }
          }
        });
        break;
      case a.GREATER:
        t({
          ...e,
          predicate: {
            ...e.predicate,
            operator: s.GT,
            value: {
              "@type": c.SCALAR,
              value: e.predicate.value["@type"] === c.SCALAR ? e.predicate.value.value : void 0
            }
          }
        });
        break;
      case a.GREATER_OR_EQ:
        t({
          ...e,
          predicate: {
            ...e.predicate,
            operator: s.GTE,
            value: {
              "@type": c.SCALAR,
              value: e.predicate.value["@type"] === c.SCALAR ? e.predicate.value.value : void 0
            }
          }
        });
        break;
      case a.LOWER:
        t({
          ...e,
          predicate: {
            ...e.predicate,
            operator: s.LT,
            value: {
              "@type": c.SCALAR,
              value: e.predicate.value["@type"] === c.SCALAR ? e.predicate.value.value : void 0
            }
          }
        });
        break;
      case a.LOWER_OR_EQ:
        t({
          ...e,
          predicate: {
            ...e.predicate,
            operator: s.LTE,
            value: {
              "@type": c.SCALAR,
              value: e.predicate.value["@type"] === c.SCALAR ? e.predicate.value.value : void 0
            }
          }
        });
        break;
      case a.BETWEEN:
        t({
          ...e,
          predicate: {
            ...e.predicate,
            operator: s.BETWEEN,
            value: {
              "@type": c.RANGE,
              maxInclusive: e.predicate.value["@type"] === c.RANGE ? e.predicate.value.maxInclusive : void 0,
              minInclusive: e.predicate.value["@type"] === c.RANGE ? e.predicate.value.minInclusive : void 0
            }
          }
        });
        break;
    }
  }, [t, e, R]);
  return /* @__PURE__ */ I(G, { children: [
    S ? /* @__PURE__ */ I(Y, { children: [
      /* @__PURE__ */ d(
        Z,
        {
          value: u,
          onFocus: n,
          onBlur: () => E(),
          options: w,
          onSelect: (p) => V(p)
        }
      ),
      /* @__PURE__ */ d(H, { type: u })
    ] }) : /* @__PURE__ */ d(G, {}),
    /* @__PURE__ */ d(K, { $iseditable: S, children: U })
  ] });
}), K = o.div`
    width: calc(100% - 25px);
    ${({ $iseditable: i }) => `opacity: ${i};`}
}

.ant-select-selector {
    box-shadow: none !important;
}
`, Y = o.div`
    display: flex;
    gap: 6px;

    .ant-select-selector {
        box-shadow: none !important;
    }
`, Z = o(C)`
    &&& {
        height: 100%;
        max-height: 100%;
        width: 100%;
        line-height: 20px;

        &&& .ant-select-single {
            line-height: 20px;
        }

        &&& .ant-select-selector {
            width: 100%;
            height: 32px;
            align-items: center;
            padding: 0 2px;
        }

        &&& .ant-select {
            line-height: 20px;
        }

        &&& .ant-select-selection-item {
            height: 24px;
            line-height: 24px;
        }
    }
`;
export {
  de as default
};
//# sourceMappingURL=FilterInputs.js.map
